import firebase from 'firebase/app'
import firebaseApp from '../../firebase-app'

export default {
  namespaced: true,
  getters: {
    googleFederated (state, getters, { user }) {
      if (!user) {
        return null
      }
      return user.providerData.find(o => o.providerId === firebase.auth.GoogleAuthProvider.PROVIDER_ID)
    },
    emailFederated (state, getters, { user }) {
      if (!user) {
        return null
      }
      return user.providerData.find(o => o.providerId === firebase.auth.EmailAuthProvider.PROVIDER_ID)
    },
    multipleAuth (state, getters, { user }) {
      if (!user) {
        return false
      }
      return user.providerData.length > 1
    }
  },
  actions: {
    async updateProfile ({ rootState: { user } }, { displayName, email }) {
      if (!user) {
        return
      }
      await user.updateProfile({ displayName, email })
    },

    async updatePassword ({ commit, rootState: { user }, getters }, { password }) {
      if (!user) {
        return
      }
      if (getters.emailFederated) {
        await user.updatePassword(password)
      } else {
        const credential = firebase.auth.EmailAuthProvider.credential(user.email, password)
        const { user: newUser } = await user.linkWithCredential(credential)
        await firebaseApp.auth().currentUser.reload()
        commit('USER_UPDATE', { user: newUser }, { root: true })
      }
    },

    async unlinkGoogle ({ commit, rootState: { user } }) {
      if (!user) {
        return
      }
      await user.unlink(firebase.auth.GoogleAuthProvider.PROVIDER_ID)
      await firebaseApp.auth().currentUser.reload()
      commit('USER_UPDATE', { user }, { root: true })
    },

    async linkGoogle (commit, { rootState: { user } }) {
      if (!user) {
        return
      }
      const provider = new firebase.auth.GoogleAuthProvider().addScope('https://www.googleapis.com/auth/plus.login')
      const { user: newUser } = await user.linkWithPopup(provider)
      await firebaseApp.auth().currentUser.reload()
      commit('USER_UPDATE', { user: newUser }, { root: true })
    }
  }
}
